module.exports = __webpack_public_path__ + "static/media/edit.6c1ce945.svg";